const API_BASE = "http://127.0.0.1:8000/api";

async function handleFetch(url, options = {}) {
  try {
    const res = await fetch(url, options);
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}: ${res.statusText}`);
    }
    return res.json();
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
}

export async function fetchProtocols() {
  return handleFetch(`${API_BASE}/protocols`);
}

export async function ingestDocument(data) {
  return handleFetch(`${API_BASE}/ingest`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}

export async function ingestFileUpload(file, title = "", roles = "", department = "") {
  const formData = new FormData();
  formData.append("file", file);
  if (title) formData.append("title", title);
  if (roles) formData.append("roles", roles);
  if (department) formData.append("department", department);

  return handleFetch(`${API_BASE}/ingest/upload`, {
    method: "POST",
    body: formData,
  });
}

export async function searchProtocols(query) {
  return handleFetch(`${API_BASE}/search?q=${encodeURIComponent(query)}`);
}

export async function generateProtocol(data) {
  return handleFetch(`${API_BASE}/generate`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}

export async function saveVersion(data) {
  return handleFetch(`${API_BASE}/versions`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}

// New knowledge management functions
export async function fetchDocuments() {
  return handleFetch(`${API_BASE}/documents`);
}

export async function fetchDocument(documentId) {
  return handleFetch(`${API_BASE}/documents/${documentId}`);
}

export async function fetchSuggestions() {
  return handleFetch(`${API_BASE}/suggestions`);
}

export async function deleteDocument(documentId) {
  return handleFetch(`${API_BASE}/documents/${documentId}`, {
    method: "DELETE",
  });
}

// Graph visualization functions
export async function fetchGraphData(params = {}) {
  const queryParams = new URLSearchParams();
  
  if (params.includeDocuments !== undefined) queryParams.append('include_documents', params.includeDocuments);
  if (params.includeProtocols !== undefined) queryParams.append('include_protocols', params.includeProtocols);
  if (params.minSimilarity !== undefined) queryParams.append('min_similarity', params.minSimilarity);
  if (params.roleFilter) queryParams.append('role_filter', params.roleFilter);
  if (params.departmentFilter) queryParams.append('department_filter', params.departmentFilter);
  
  const url = `${API_BASE}/graph${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  return handleFetch(url);
}

export async function fetchGraphClusters() {
  return handleFetch(`${API_BASE}/graph/clusters`);
}

export async function updateDocument(documentId, updates) {
  return handleFetch(`${API_BASE}/documents/${documentId}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(updates),
  });
}

export async function deleteProtocol(protocolId) {
  return handleFetch(`${API_BASE}/protocols/${protocolId}`, {
    method: "DELETE",
  });
}

export async function updateProtocol(protocolId, updates) {
  return handleFetch(`${API_BASE}/protocols/${protocolId}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(updates),
  });
}
